import React, { useEffect } from 'react'

const AiChatbot = (props) => {
  useEffect(() => {
    if (props.block.settings.event_id) {
      const script = document.createElement('script')
      script.src = 'https://app-loader.neurun.com'
      script.type = 'module'
      script.async = true
      document.body.appendChild(script)

      return () => {
        document.body.removeChild(script)
      }
    }
  }, [props.block.settings.event_id])

  return props.block.settings.event_id ? (
    <div>
      <search-bar event={props.block.settings.event_id}></search-bar>
    </div>
  ) : null
}

export default AiChatbot
